import { LoadingUI } from '@fozito/common-ui';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

const LoadingPageStyled = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content:center;
  z-index: 9999;
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background: #FFFFFF;
    border-radius: 6px;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #363565;
    }
  }
`;

type Props = {};
type Ref = {
  open: () => void;
  close: () => void;
  setVisible: (value: boolean) => void;
};
export const usePageLoadingRef = () => useRef<Ref>(null);
export const globalPageLoadingRef = React.createRef<Ref>();
export const setPageLoading = (value: boolean) => globalPageLoadingRef.current?.setVisible(value);
const PageLoading = forwardRef<Ref, Props>(({ }, ref) => {
  const [open, setOpen] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
    setVisible: (val) => setOpen(val),
  }));
  if (!open) return null;
  return (
    <LoadingPageStyled>
      <div className="box">
        <LoadingUI />
      </div>
    </LoadingPageStyled>
  );
});
PageLoading.displayName = 'PageLoading';
export default PageLoading;

